module.exports = __webpack_public_path__ + "static/media/6.5694a536.svg";